module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item__header"
  }, [(_vm.item.status !== 'item_refunded') ? _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "color": "red"
    },
    on: {
      "change": function($event) {
        _vm.$emit('input', _vm.item)
      }
    },
    model: {
      value: (_vm.item.refund),
      callback: function($$v) {
        _vm.$set(_vm.item, "refund", $$v)
      },
      expression: "item.refund"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "item__content"
  }, [_c('app-card', {
    attrs: {
      "image": _vm.productImage,
      "title": _vm.productName,
      "subtitle": _vm.itemPrice,
      "description": _vm.itemShippingCost
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item__footer"
  }, [(_vm.item.refund) ? _c('vue-numeric', {
    attrs: {
      "currency": "$",
      "separator": ",",
      "precision": 2,
      "min": 0.01,
      "max": _vm.itemMaxRefundAmount
    },
    on: {
      "blur": function($event) {
        _vm.$emit('input', _vm.item)
      }
    },
    model: {
      value: (_vm.item.refund_amount_in_dollar),
      callback: function($$v) {
        _vm.$set(_vm.item, "refund_amount_in_dollar", $$v)
      },
      expression: "item.refund_amount_in_dollar"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "item__footer"
  }, [_c('div', [_vm._v("Quantity: " + _vm._s(_vm.itemQuantity))]), _vm._v(" "), _c('label', {
    class: _vm.itemStatus.toLowerCase()
  }, [_vm._v(_vm._s(_vm.itemStatus))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb8165ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/payments/components/shop_item.vue
// module id = 1878
// module chunks = 180